import React from 'react';
import { CookieManager } from './types';
import { CookiesProvider } from 'react-cookie';
import { CreateReactCookieManager } from './adapters/react-cookie';

let cookieManager: CookieManager;
const currentDomain = window.location.hostname;
const cookieDomain = currentDomain.includes('localhost') ? currentDomain : `.${currentDomain}`
const cookiePrefix = 'student_'

export const setCookieManager = (manager: CookieManager) => {
    cookieManager = manager;
};

export const getCookieManager = (): CookieManager => {
    if (!cookieManager) {
        throw new Error('Cookie manager not initialized');
    }
    return cookieManager;
};

const getDomainOptions = (options?: any): any => ({
    ...options,
    domain: cookieDomain
});

export const useCookie = () => {
    const manager = getCookieManager();
    return {
        set: (name: string, value: string, options?: any) => manager.set(`${cookiePrefix}${name}`, value, getDomainOptions(options)),
        get: (name: string) => manager.get(`${cookiePrefix}${name}`),
        remove: (name: string, options?: any) => manager.remove(`${cookiePrefix}${name}`, getDomainOptions(options)),
        getAll: () => {
            const allCookies = manager.getAll();
            return Object.entries(allCookies)
                .filter(([key]) => key.startsWith(cookiePrefix))
                .reduce((acc, [key, value]) => ({ ...acc, [key.replace(cookiePrefix, '')]: value }), {});
        },
        has: (name: string) => manager.has(`${cookiePrefix}${name}`),
    };
};

interface CookieProviderProps {
    children: React.ReactNode;
}

const ChildComponent = ({ children }: { children: React.ReactNode }) => {
    const manager = CreateReactCookieManager();
    setCookieManager(manager);
    return (<>{children}</>);
};

export const CookieProvider = ({ children }: CookieProviderProps) => {
    return (
        <CookiesProvider >
            <ChildComponent >
                {children}
            </ChildComponent>
        </CookiesProvider>
    );
};

